// We want these to match the API schema as closely as possible

import type { JSONSchema7 } from 'json-schema';

import type { DeepReadonly } from './types';

export const databricksJsonSchema = {
  $schema: 'http://json-schema.org/draft-07/schema#',
  type: 'object',
  properties: {
    max_tokens: {
      type: ['integer', 'null'],
      description: 'The maximum number of tokens that can be generated in the chat completion.',
      minimum: 1,
      default: 4096,
    },
    temperature: {
      type: ['number', 'null'],
      description: 'Sampling temperature for randomness in response generation.',
      minimum: 0,
      maximum: 2,
      default: 1,
    },
    top_p: {
      type: ['number', 'null'],
      description: 'Nucleus sampling probability threshold, limiting considered tokens.',
      minimum: 0,
      maximum: 1,
      default: 1,
    },
    top_k: {
      type: ['integer', 'null'],
      description: 'Limits the number of highest probability tokens considered at each step.',
      minimum: 1,
    },
    stop: {
      type: ['array', 'null'],
      description: 'Up to 4 sequences where the API will stop generating further tokens.',
      items: {
        type: 'string',
      },
    },
    frequency_penalty: {
      type: ['number', 'null'],
      description:
        'Penalizes new tokens based on their existing frequency in the text, decreasing repetition likelihood.',
      minimum: -2.0,
      maximum: 2.0,
      default: 0,
    },
    presence_penalty: {
      type: ['number', 'null'],
      description:
        'Penalizes new tokens based on whether they appear in the text, increasing likelihood of new topics.',
      minimum: -2.0,
      maximum: 2.0,
      default: 0,
    },
  },
  additionalProperties: false,
} as const;

// this confirms that the type is a valid JSON schema, but we want it as a `const` so we can use it to index the properties
export const databricksSchemaProperties: DeepReadonly<JSONSchema7> = databricksJsonSchema;

export const retrieveDatabricksParameters = (): string[] => Object.keys(databricksJsonSchema.properties);
